import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import BingMaps from 'ol/source/BingMaps';

export const baseLayers = {
    osm: new TileLayer({
        id: 'OSM',
        source: new OSM(),
        visible: false,
        zIndex: -10
    }),
    bing: new TileLayer({
        visible: false,
        zIndex: -10,
        source: new BingMaps({
            key: 'ApTJzdkyN1DdFKkRAE6QIDtzihNaf6IWJsT-nQ_2eMoO4PN__0Tzhl2-WgJtXFSp',
            imagerySet: 'AerialWithLabels',
            maxZoom: 19
        })
    })
};